import { SegmentedControl, Box, Text } from '@mantine/core'

interface Props {
  value: string | null;
  onChange: (value: string) => void;
}

export default function MountTypeSelector ({ value, onChange }: Props) {
  return (
    <Box>
      <Text size="sm" weight={500} mb={8} sx={{ color: 'var(--gs-text)' }}>
        How is the optic mounted?
      </Text>
      <SegmentedControl
        value={value ?? 'MountOnly'}
        onChange={onChange}
        data={[
          { label: 'Mount + Optic', value: 'MountOnly' },
          { label: 'Integrated Scope', value: 'Integrated' },
          { label: 'Iron Sights', value: 'IronSights' }
        ]}
        fullWidth
        styles={{
          root: {
            background: 'var(--gs-surface2)',
            border: '1px solid var(--gs-border)',
            borderRadius: 6,
            padding: 4
          },
          control: {
            borderColor: 'var(--gs-border)',
            '&[data-active]': {
              background: 'var(--gs-accent)',
              color: '#fff',
              borderColor: 'var(--gs-accent)'
            }
          },
          label: {
            color: 'var(--gs-text)',
            fontSize: 12,
            fontWeight: 500
          }
        }}
      />
    </Box>
  )
}
